import dynamic from 'next/dynamic'

import { Loading } from '../../../../../loading'

export const DynamicProductPagePrescriptionTypeSelectionModalContent = dynamic(
  async () =>
    import('./ProductPagePrescriptionTypeSelectionModalContent').then(
      (mod) => mod.ProductPagePrescriptionTypeSelectionModalContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
